import { Component, inject, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Company } from "src/model/company.model";
import { CustomerAccount } from "src/model/customerAccount.model";
import { FinanceAccount } from "src/model/financeAccount.model";
import { BusinessService } from "src/services/business.service";
import { CompanyService } from "src/services/company.service";
import { FinanceAccountService } from "src/services/finance-account.service";

export interface BankInDetails {
  bankInAccount: CustomerAccount;
  amount: number;
}

export interface AppliedBranchDetails {
  appliedBranch: Company;
  amount: number;
  kerja?: number;
  carryAmount?: number;
  remainingAmount?: number;
  overflow?: number;
}

@Component({
  selector: "app-apply-asset-request",
  standalone: false,
  templateUrl: "./apply-asset-request.component.html",
  styleUrl: "./apply-asset-request.component.scss",
})
export class ApplyAssetRequestComponent implements OnInit {
  protected disabledSubmit = false;
  // need to show different component based on type
  protected companyId: number;
  protected companyCode: string;
  protected loggedInUser: string;
  protected defaultFinanceAccount: FinanceAccount;

  protected activeModal = inject(NgbActiveModal);
  protected companyService = inject(CompanyService);
  protected businessService = inject(BusinessService);
  protected financeAccountService = inject(FinanceAccountService);
  @Input() type: string;
  protected seletedApplyOpt: string;
  protected applyOptions = ["TICKET", "KERJA", "EXPENSES", "CONTRA"];

  async ngOnInit() {
    this.companyId = Number(sessionStorage.getItem("companyId"));
    this.companyCode = sessionStorage.getItem("companyName");
    this.loggedInUser = sessionStorage.getItem("username");

    this.defaultFinanceAccount = await this.getDefaultFinanceAccounts();
  }

  async getDefaultFinanceAccounts() {
    if (this.defaultFinanceAccount == undefined) {
      // response length should be exactly 1
      const business = await this.businessService.getAllBusinesses({ companyId: this.companyId });

      if (business.length > 0) {
        const defaultFinanceBanks = await this.financeAccountService.getAllFinanceAccounts({ businessId: business[0].Id });

        //so far no default bank selection so always point to first one in the list
        return defaultFinanceBanks[0];
      }
    }
  }

  submit() {
    //every type at the end need to pass certain values to:
    //generate request message
    //post api request
    //so each component must return a bunch of values
  }

  reset() {
    this.activeModal.close();
  }
}
